import { CardMoreInfosContainer, CardMoreInfosWrapper } from './elements';

import ContactIcon from 'src/components/Icons/ContactIcon';
import FAQIcon from 'src/components/Icons/FAQIcon';
import FinanceIcon from 'src/components/Icons/FinanceIcon';
import ModalitesIcon from 'src/components/Icons/AdmissionProcess/Modalites';
import React from 'react';
import { Sentence } from '../Typography';

const CardMoreInfos = React.memo(({ title, link, fromFormationsPage }) => {
  return (
    <CardMoreInfosWrapper>
      <CardMoreInfosContainer to={link} state={{ fromFormationsPage: fromFormationsPage }}>
        <div
          css={{
            marginBottom: 16,
            width: 75,
          }}
        >
          {title === 'Financements' ? (
            <FinanceIcon />
          ) : title === 'Questions fréquentes' ? (
            <FAQIcon />
          ) : title === 'Contactez-nous' ? (
            <ContactIcon />
          ) : title === "Modalités d'accès" ? (
            <ModalitesIcon />
          ) : null}
        </div>

        <Sentence
          css={{
            fontSize: 16,
            fontWeight: 'bold',
            '@media only screen and (min-width: 600px) and (max-width: 900px)': {
              fontSize: 14,
            },
          }}
        >
          {title}
        </Sentence>
      </CardMoreInfosContainer>
    </CardMoreInfosWrapper>
  );
});
export default CardMoreInfos;
